<template>
  <v-dialog
    v-model="show"
    max-width="550"
    content-class="happy_birthday"
    transition="spin-in-out-transition"
  >
    <v-card
      class="main-card"
      elevation="0"
      dark
      style="z-index: 2"
      height="550"
    >
      <slot :close="close" ></slot>
    </v-card>
    <confetti-background />
  </v-dialog>
</template>

<script>
import ConfettiBackground from '@/components/Layout/SystemNotification/Template/components/ConfettiBackground.vue';
import templateMixin from './templateMixin';

export default {
  name: 'Birthday',
  components: { ConfettiBackground },
  mixins: [templateMixin],
};
</script>

<style lang="sass"></style>
